<span class="gup-O-status" [ngClass]="classes">{{statusList[code]}}</span>
